import React from 'react';
import { Box, Skeleton, Theme, useMediaQuery } from '@mui/material';
import useScreenSize from '../../utils/useScreenSize';
import FeatureStatusChip from '../cards/MuiCard/MuiCardBase/FeatureStatusChip';
import { CoverImage } from '../cards/MuiCard/MuiCardBase/MuiCardBaseCover';

const SummaryCoverImage: React.FC<{
  isLoading: boolean;
  coverImage?: string;
  isNew?: boolean;
  title?: string;
}> = ({ isLoading, coverImage, isNew, title }) => {
  const { isXsScreen, isSmScreen, isMdScreen, isLgScreen } = useScreenSize();
  const isDesktopScreen = isMdScreen || isLgScreen;
  const flexDirectionBreakPoint = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  const getCoverImageHeight = () => {
    if (isDesktopScreen) return 422;
    if (isSmScreen) return 354;
    return 316;
  };

  const getCoverImageWidth = () => {
    if (isDesktopScreen) return 298;
    if (isSmScreen) return 250;
    return 224;
  };

  return (
    <Box
      sx={{
        minWidth: getCoverImageWidth(),
        maxWidth: getCoverImageWidth(),
        height: getCoverImageHeight(),
        position: 'relative',
        display: 'flex',
        marginRight: flexDirectionBreakPoint ? 'auto' : 0,
        marginLeft: flexDirectionBreakPoint ? 'auto' : 0,
        alignItems: flexDirectionBreakPoint ? 'center' : 'flex-start',
      }}
      data-testid='summary-cover-image-container'
    >
      {isLoading && <Skeleton height={`${getCoverImageHeight()}px`} />}
      {!isLoading && coverImage && (
        <CoverImage
          cover={coverImage}
          title={title}
          className='summary-cover-image'
          customSx={{
            ':hover': { boxShadow: 'none' },
            height: '100%',
          }}
        />
      )}
      {!isLoading && isNew && (
        <FeatureStatusChip size={isXsScreen ? 'small' : 'medium'} />
      )}
    </Box>
  );
};

export default SummaryCoverImage;
